export default class PopupModel {
    constructor() {
        this.fields = {
            "incdttm": { "label": "Date/time", "class": "full-width" },
            "location": { "label": "Location", "class": "full-width" },
            "sdot_coldesc": { "label": "SDOT Description", "class": "full-width" },
            "pedcount": { "label": "Number of pedestrians"},
            "severitydesc": { "label": "Severity" },
            "pedcylcount": { "label": "Number of cyclists" },
            "injuries": { "label": "Injuries" },
            "fatalities": { "label": "Fatalities"},
            "seriousinjuries": { "label": "Serious injuries" }
        };
    }

    /**
     * HTML for a field in a popup.
     */
    field(key, data) {
        let cssClass = (this.fields[key].class) ? this.fields[key].class : '';

        return `<p class="${ cssClass }">
                    <strong>${this.fields[key].label}</strong>: ${data}
                </p>`;
    }

    /**
     * Make the popup for a marker
     */
    content(row, popupFields) {
        let popup = '';

        Object.keys(row).forEach(key => {
            if (popupFields.indexOf(key) > -1) {
                popup += this.field(key, row[key]);
            }
        });

        return popup;
    }
}


// WEBPACK FOOTER //
// ./js/Models/PopupModel.js